<template>

  <div class="my-collection">

    <div ref="collectionTitle" class="title">{{ $t('我的收藏') }}</div>

    <div class="card">

      <template v-if="hasCollectionData">

        <div class="collection-group" v-for="(e, i) in goodFreshList" :key="i">

          <div class="collection-date margin-top-24">{{ i }}</div>

          <div class="list">

            <div ref="collectionCard" class="list-box" v-for="(item, index) in e" :key="index">

              <div class="img-container">

                <img :src="item.cover" alt="" class="box-img">

              </div>

              <div class="box-bottom">

                <div class="box-bottom-tit line2">{{ item.name }}</div>

                <div class="box-bottom-box">

                  <div class="box-bottom-box-l">

                    ￥<span class="text-20">{{ item.price }}</span>

                  </div>

                  <div class="box-bottom-box-r" @click="gotoDetail(item)">

                    <div class="box-bottom-box-rl">

                      <img src="../../../../static/images/icon/icon07.png" alt="">

                    </div>

                    <div class="box-bottom-box-rr">{{ $t('购买') }}</div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </template>

      <div class="zanwu" v-else>

        <img src="../../../../static/images/my/zanwu.png" alt="">

        <div class="text-999 text-14">{{ $t('暂无数据') }}</div>

      </div>

    </div>

    <div ref="collectionPagination" class="pagination" :class="{ 'pagination-h5': isH5 }">

      <el-pagination background layout="prev, pager, next" :page-size="page_size" :total="total"

        :small="isH5" @current-change="onCurrentChange"></el-pagination>

    </div>

  </div>

</template>



<style scoped>

.el-input--prefix /deep/ .el-input__inner {

  border: 1px solid #fd3b00;

  border-right: none;

  border-radius: 8px 0 0 8px;

}

</style>



<script>

import UserCenterTemp from "@/components/UserCenterTemp";

import SummaryBar from "@/components/SummaryBar";

import ShortcutBar from "@/components/ShortcutBar";

import rightSuspension from "@/components/rightSuspension.vue";

import { collectList } from '@/api/user';



export default {

  name: "MyCollection",

  components: {

    "user-center-temp": UserCenterTemp,

    "summary-bar": SummaryBar,

    "shortcut-bar": ShortcutBar,

    rightSuspension,

  },

  data() {

    return {

      page_size: 0,

      total: 0,

      goodFreshList: {},

      page: 1,

      isH5: typeof window !== 'undefined' && window.innerWidth < 768,
      // 收藏页面入场动画实例，用于组件销毁时释放动画资源
      collectionEntranceAnimation: null,

    };

  },

  computed: {

    hasCollectionData() {

      if (!this.goodFreshList) return false;

      if (Array.isArray(this.goodFreshList)) {

        return this.goodFreshList.length > 0;

      }

      return Object.keys(this.goodFreshList).length > 0;

    },

  },

  mounted() {

    this.onCollectList();

    this.updateIsH5();

    window.addEventListener('resize', this.updateIsH5);

  },

  beforeDestroy() {

    window.removeEventListener('resize', this.updateIsH5);

    if (this.collectionEntranceAnimation) {

      this.collectionEntranceAnimation.progress(1).kill();

    }

  },

  methods: {

    /** 播放收藏列表的入场动效 */
    playCollectionEntranceAnimation() {

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

        return;

      }

      if (this.collectionEntranceAnimation) {

      this.collectionEntranceAnimation.progress(1).kill();

      }

      const targets = [this.$refs.collectionTitle]
        .concat(this.$refs.collectionCard || [])
        .concat([this.$refs.collectionPagination])
        .filter(Boolean);

      this.collectionEntranceAnimation = this.$gsap.fromTo(targets, {
        y: 16,
        opacity: 0,
      }, {
        y: 0,
        opacity: 1,
        duration: 0.45,
        stagger: 0.08,
        ease: 'power2.out',
        onComplete: () => {
          this.$gsap.set(targets, { clearProps: 'opacity,transform' });
        },
      });

    },

    updateIsH5() {

      this.isH5 = window.innerWidth < 768;

    },

    onCurrentChange(e) {

      this.page = e;

      this.onCollectList();

    },

    gotoDetail(e) {

      this.$router.push({ name: 'ProductDetails', params: { id: e.product_id } });

    },

    onCollectList() {

      collectList({ page: this.page }).then(res => {

        this.page_size = res.data.per_page;

        this.total = res.data.total;

        this.goodFreshList = res.data.data || {};

        this.$nextTick(() => {

          this.playCollectionEntranceAnimation();

        });

      });

    },

  },

};

</script>



<style scoped lang="scss">

.rightsearch {

  width: 72px;

  height: 34px;

  background: #fd3b00;

  border-radius: 8px;

  text-align: center;

  line-height: 34px;

  color: #fff;

  cursor: pointer;

}



.el-icon-shopping-cart-2 {

  font-size: 20px;

}



.shopping-cart .products {

  min-height: 300px;

  padding-bottom: 10px;

}



.my-collection {

  box-sizing: border-box;

}



.title {

  margin-top: 16px;

  font-size: 18px;

  font-weight: bold;

  color: #333333;

}



.card {

  height: 70vh;

  overflow-y: auto;

}



.card::-webkit-scrollbar {

  display: none;

}



.zanwu {

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  min-height: 240px;

  padding: 48px 0;



  img {

    width: 80px;

    height: 80px;

    margin-bottom: 12px;

  }

}



.collection-date {

  font-size: 16px;

  font-weight: 600;

  color: #333;

}



.list {

  display: flex;

  flex-wrap: wrap;

  padding: 0 12px 12px;



  .list-box {

    width: calc(25% - 18px);

    margin-right: 24px;

    margin-top: 32px;

    position: relative;

    transition: all 0.3s ease;

    border-radius: 8px;

    padding: 12px;

    box-sizing: border-box;

    cursor: pointer;

    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);



    &:hover {

      transform: translateY(-5px);



      .img-container {

        overflow: hidden;

        border-radius: 8px;



        .box-img {

          transform: scale(1.2);

        }

      }

    }



    .img-container {

      width: 100%;

      height: 237px;

      border-radius: 8px;

      overflow: hidden;

    }



    .box-img {

      width: 100%;

      height: 100%;

      border-radius: 8px;

      object-fit: cover;

      transition: transform 0.3s ease;

    }



    .box-bottom {

      margin-top: 16px;



      .box-bottom-tit {

        width: 100%;

        line-height: 20px;

        height: 40px;

      }



      .box-bottom-box {

        width: 100%;

        display: flex;

        align-items: center;

        justify-content: space-between;

        margin-top: 10px;



        .box-bottom-box-l {

          color: #85674B;

          font-size: 14px;

        }



        .box-bottom-box-r {

          background: #FFFFFF;

          border: 1px solid #000;

          display: flex;

          border-radius: 4px;



          .box-bottom-box-rl {

            padding: 8px 16px;

            cursor: pointer;



            img {

              width: 18px;

              height: 18px;

              display: block;

            }

          }



          .box-bottom-box-rr {

            padding: 8px 16px;

            font-size: 14px;

            background: #000;

            color: #FFFFFF;

            cursor: pointer;

          }

        }

      }

    }

  }



  .list-box:nth-child(4n) {

    margin-right: 0;

  }

}



.pagination {

  width: 100%;

  display: flex;

  justify-content: center;

  margin-top: 40px;

}



@media (max-width: 767px) {

  .my-collection {

    width: 100%;

    padding: 0 0 24px;

    box-sizing: border-box;

  }



  .title {

    margin-top: 0;

    font-size: 16px;

    padding: 0 4px;

  }



  .card {

    height: auto;

    overflow: visible;

  }



  .collection-date {

    font-size: 14px;

    color: #666;

    padding: 0 4px;

    margin-top: 16px !important;

  }



  .collection-group:first-child .collection-date {

    margin-top: 12px !important;

  }



  .list {

    display: grid;

    grid-template-columns: repeat(2, minmax(0, 1fr));

    gap: 10px;

    padding: 8px 0 0;



    .list-box {

      width: 100%;

      margin-right: 0;

      margin-top: 0;

      padding: 8px;

      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);



      &:hover {

        transform: none;



        .box-img {

          transform: none;

        }

      }



      .img-container {

        height: auto;

        aspect-ratio: 1;

      }



      .box-bottom {

        margin-top: 10px;



        .box-bottom-tit {

          height: auto;

          min-height: 36px;

          font-size: 13px;

          line-height: 18px;

        }



        .box-bottom-box {

          margin-top: 8px;

          flex-wrap: wrap;

          gap: 6px;



          .box-bottom-box-l {

            font-size: 12px;



            .text-20 {

              font-size: 16px;

            }

          }



          .box-bottom-box-r {

            margin-left: auto;



            .box-bottom-box-rl,

            .box-bottom-box-rr {

              padding: 6px 8px;

              font-size: 12px;

            }



            .box-bottom-box-rl img {

              width: 16px;

              height: 16px;

            }

          }

        }

      }

    }



    .list-box:nth-child(4n) {

      margin-right: 0;

    }

  }



  .zanwu {

    min-height: 200px;

    background: #fff;

    border-radius: 8px;

    margin-top: 12px;

  }



  .pagination {

    margin-top: 16px;

  }



  .pagination-h5 {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: center;
    width: 100%;
    padding: 0 4px;
    box-sizing: border-box;

    /deep/ .el-pagination {
      margin: 0 auto;
      justify-content: center;
    }
  }

}

</style>





// WEBPACK FOOTER //
// src/view/my/components/MyCollection.vue